/* eslint-disable dot-notation */
import React from 'react';
import { Switch, Card, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import classes from './BaseSection.module.scss';

export const BaseSection = ({ name, onView, ordinal = 1, contentField = 0, enabled = true }) => {
  return (
    <figure className={classes.figure}>
      {ordinal && <figcaption>#{ordinal}</figcaption>}

      <Card className={classes.baseSection}>
        <div className={classes['baseSection__content']}>
          <div className={classes['baseSection__content__left']}>
            <Switch disabled checked={enabled} />
            <span>
              <h5 className={classes['baseSection__title']}>Name of Section</h5>
              <span className={classes['baseSection__label--medium']}>{name}</span>
            </span>
          </div>
          <div className={classes['baseSection__content__center']}>
            <span>
              <h5 className={classes['baseSection__title']}>Content Field</h5>
              <span className={classes['baseSection__label']}>{contentField}</span>
            </span>
          </div>
          <div className={classes['baseSection__content__right']}>
            <Button onClick={onView} type="link" icon={<InfoCircleOutlined />} />
          </div>
        </div>
      </Card>
    </figure>
  );
};
